import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {HttpClient} from '@angular/common/http';

@Injectable()
export abstract class AbstractSettingsService {
    protected readonly httpClient: HttpClient;
    protected readonly configService: ConfigService;

    protected constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    protected async getSettings(): Promise<any> {
        return await this.httpClient.get(this.configService.baseUrl() + '/settings').toPromise();
    }

    protected async getSettingsWithURL(settingUrl: String): Promise<any> {
        return await this.httpClient.get(this.configService.baseUrl() + settingUrl).toPromise();
    }

    public async getAssetPerformance(): Promise<any> {
        return await this.httpClient.get(this.configService.baseUrl() + '/getAssetPerformanceLists').toPromise();
    }
}
